// extracted by mini-css-extract-plugin
export default {"headerActions":"NhlStatsEmptyNetPage_headerActions__oPSFo"};